import { useState, useEffect } from 'react';

const NewsDetailModal = () => {
    const [selectedNews, setSelectedNews] = useState(null);

    useEffect(() => {
        const modalElement = document.getElementById('newsDetailModal');
        if (modalElement) {
            modalElement.addEventListener('show.bs.modal', (event) => {
                const button = event.relatedTarget;
                const newsData = button?.getAttribute('data-news');
                if (newsData) {
                    try {
                        const parsedNews = JSON.parse(newsData);
                        setSelectedNews(parsedNews);
                    } catch (error) {
                        console.error('Error parsing news data:', error);
                        setSelectedNews(null);
                    }
                }
            });

            modalElement.addEventListener('hidden.bs.modal', () => {
                setSelectedNews(null);
            });
        }

        return () => {
            if (modalElement) {
                modalElement.removeEventListener('show.bs.modal', null);
                modalElement.removeEventListener('hidden.bs.modal', null);
            }
        };
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        // Check if the date is valid
        if (isNaN(date.getTime())) {
            return dateString; // Return the original string if it can't be parsed
        }
        
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const getTypeDisplayName = (type) => {
        switch (type) {
            case 'event':
                return 'Event';
            case 'release':
                return 'Product Release';
            default:
                return 'News';
        }
    };

    return (
        <div className="modal fade" id="newsDetailModal" tabIndex="-1" aria-labelledby="newsDetailModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="newsDetailModalLabel">
                            {selectedNews ? selectedNews.title : 'News Details'}
                        </h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        {selectedNews && (
                            <div>
                                <div className="row mb-3">
                                    <div className="col">
                                        <span className="badge bg-primary me-2">{getTypeDisplayName(selectedNews.type)}</span>
                                        <span className="text-muted">{formatDate(selectedNews.date)}</span>
                                    </div>
                                </div>
                                
                                {selectedNews.titleImg && (
                                    <div className="mb-3">
                                        <img 
                                            src={selectedNews.titleImg} 
                                            alt={selectedNews.title} 
                                            className="img-fluid rounded" 
                                            style={{ maxHeight: '200px', objectFit: 'contain' }}
                                        />
                                    </div>
                                )}

                                <div className="mb-3">
                                    <h4>{selectedNews.title}</h4>
                                </div>

                                {selectedNews.fullDescription ? (
                                    <div className="mb-3">
                                        <p className="lead">{selectedNews.shortDescription}</p>
                                        <div className="mt-3">
                                            {selectedNews.fullDescription.split('\n').map((paragraph, index) => (
                                                <p key={index} className="mb-2">{paragraph}</p>
                                            ))}
                                        </div>
                                    </div>
                                ) : (
                                    <div className="mb-3">
                                        <p dangerouslySetInnerHTML={{ __html: selectedNews.shortDescription }}></p>
                                    </div>
                                )}

                                {selectedNews.url && selectedNews.type === 'release' && (
                                    <div className="mt-4">
                                        <a 
                                            href={selectedNews.url} 
                                            target={selectedNews.target || '_blank'} 
                                            rel="noreferrer"
                                            className="btn btn-primary"
                                        >
                                            View Full Document
                                        </a>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsDetailModal;
